import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["data", "entity", "field", "hideLabel", "label", "onChange", "onRemove", "placeholder", "type", "value"];
/**
 * this wraps TextInput with a button to the right that
 * allows calling a remove function for the value.
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row } from 'reactstrap';
import { kebabCase } from 'lodash';
import TextInput from './textInput';
const RemovableTextInput = _ref => {
  let _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data,
    entity = _ref.entity,
    field = _ref.field,
    _ref$hideLabel = _ref.hideLabel,
    hideLabel = _ref$hideLabel === void 0 ? false : _ref$hideLabel,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '\u00a0' : _ref$label,
    onChange = _ref.onChange,
    onRemove = _ref.onRemove,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 9
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, otherProps, {
    data: data,
    entity: entity,
    field: field,
    hideLabel: hideLabel,
    label: label,
    onChange: onChange,
    placeholder: placeholder,
    type: type,
    value: value
  }))), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(Button, {
    className: "t-rti-".concat(kebabCase(field), " tqc-control"),
    block: true,
    onClick: onRemove
  }, "Remove Other"))));
};
RemovableTextInput.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string
  }),
  entity: PropTypes.string.isRequired,
  field: PropTypes.string.isRequired,
  hideLabel: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string
};
export default RemovableTextInput;